var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix headerTag"},[_c('a',{staticClass:"fl back",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("返回")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.headerTxt))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4fc46a6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/header.vue
// module id = mCgE
// module chunks = 1